import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { color } from 'src/shared/styles/variables';
import { hexToRgba } from 'src/shared/helpers/hexToRgba';
import { colors as dsColors } from '@modernhealth/vital-foundation';
import { HeadingText20, pxToRem } from '@modernhealth/vital-components';
import { Dispatch } from 'src/config/rootStore';
import { SOURCE_TYPES } from 'src/modules/user/models/user';
import { useAnalytics } from '@modernhealth/web-analytics';

interface CrisisSupportWrapperProps {
    textOnly?: boolean;
}

const CrisisSupportWrapper = styled.div<CrisisSupportWrapperProps>(({ textOnly }) => ({
    background: textOnly ? 'transparent' : hexToRgba(dsColors.gray05, 0.5),
    borderRadius: pxToRem(4),
    padding: pxToRem(10),
    alignItems: 'center',
    textAlign: 'center',
    marginTop: textOnly ? pxToRem(32) : 0,
    cursor: 'pointer',
}));

const CrisisSupportMessage = styled.span({
    fontStyle: 'normal',
    fontWeight: 800,
    fontSize: '16px',
    lineHeight: '24px',

    /* identical to box height, or 150% */
    cursor: 'pointer',
    textDecoration: 'none',

    /* Dark Grey */
    color: color.blueBayoux,
    opacity: 0.9,

    /* Add animation */
    ':hover': {
        color: color.blueBayoux,
        textDecoration: 'underline',
        textDecorationLine: 'underline',
    },
});

interface CrisisSupportBannerProps {
    textOnly?: boolean;
    useDSComponents?: boolean;
}

const CrisisSupportBanner: React.FC<CrisisSupportBannerProps> = ({ textOnly, useDSComponents }) => {
    const { t } = useTranslation();
    const analytics = useAnalytics();
    const dispatch = useDispatch<Dispatch>();
    const bannerText = t('shared:crisis_support_banner.message');
    const Message = useDSComponents
        ? props => <HeadingText20 {...props} underline centered />
        : CrisisSupportMessage;

    useEffect(() => {
        dispatch.user.updateCrisisModalSource(SOURCE_TYPES.HOME_PAGE);
    }, [dispatch.user]);

    return (
        <CrisisSupportWrapper
            textOnly={textOnly}
            onClick={() => {
                dispatch.user.toogleShowCrisisModal();
                analytics.trackClick('homepage: crisis support', {
                    home_section: 'crisis_support',
                });
            }}
        >
            <Message>{bannerText}</Message>
        </CrisisSupportWrapper>
    );
};

export default CrisisSupportBanner;
